function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9232 7.74678C13.9876 9.81119 15.124 12.527 15.124 15.3939L16.7746 15.3939C16.7752 12.0863 15.4666 8.95554 13.0905 6.57946C10.7139 4.20397 7.58372 2.89482 4.27613 2.89541L4.27613 4.546C7.14306 4.546 9.85883 5.68238 11.9232 7.74678ZM10.3847 15.9052C10.3847 12.3168 7.35318 9.28531 3.76484 9.28531V10.9359C6.45784 10.9359 8.73412 13.2122 8.73412 15.9052L10.3847 15.9052Z",
  fill: "#343A40"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7579 15.7604C13.7591 10.4222 9.24801 5.91114 3.90987 5.91231L3.90987 7.5629C8.35385 7.5629 12.1074 11.3164 12.1074 15.7604L13.7579 15.7604Z",
  fill: "#343A40"
});

var SvgVestibularDigitalIconNew = function SvgVestibularDigitalIconNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVestibularDigitalIconNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VestibularDigitalIconNew.09cd579f.svg";
export { ForwardRef as ReactComponent };